<template>
  <div v-if="!isAllow">
    UnAuthorized Access
  </div>
  <div v-else>
    <el-row>
      <span >
        <el-button type="text" @click="add">Add New <i class="fas fa-plus-square"/></el-button>
      </span>
    </el-row>
    <el-row :gutter="20">
      <el-col :md="9">
        <el-alert
          :closable="false"
          title="Reminder"
          type="info"
          description="There is only one active tax table. Please update other tax to inactive if there is a new one."
          show-icon />
        <el-table
          v-loading="loading"
          :data="tableData"
          style="width: 100%">
          <el-table-column
            prop="effective_date"
            label="Effectivity date">
            <template slot-scope="scope">
              {{ $moment(scope.row.effective_date).format('MMMM D, Y') }}
            </template>
          </el-table-column>
          <el-table-column
            prop="status"
            label="Status">
            <template slot-scope="scope">
              {{ scope.row.status === 1 ? 'Active' : 'In active' }}
            </template>
          </el-table-column>
          <el-table-column label="Operation" align="center">
            <template slot-scope="scope">
              <el-button type="warning" size="small" @click="edit(scope.row)"><i class="fas fa-edit"/></el-button>
              <el-button type="primary" size="small" @click="details(scope.row)"><i class="fas fa-eye"/></el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: center;">
          <el-pagination :page-size="meta.per_page" :pager-count="7" :total="meta.total" :current-page.sync="meta.page" layout="total, prev, pager, next" @current-change="getAll"/>
        </div>
      </el-col>
      <el-col v-if="showDetails" :md="15">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>Tax table</span>
            <el-button style="float: right; padding: 3px 0" type="text" @click="addDetails"><i class="fas fa-plus-square"/> Add</el-button>
          </div>
          <el-table
            v-loading="loadingDetails"
            :data="tableDetails"
            border
            style="width: 100%">
            <el-table-column
              prop="description"
              label="Tax Bracket">
              <template slot-scope="scope">
                {{ splitDescription(scope.row.description) }}
              </template>
            </el-table-column>
            <el-table-column
              label="Tax details">
              <template slot-scope="scope">
                {{ scope.row.fix_tax ? Number(scope.row.fix_tax).toLocaleString(undefined, {minimumFractionDigits: 2}) + ' + ' : '' }} {{ scope.row.tax_rate || scope.row.tax_rate === 0 ? scope.row.tax_rate + '%' : '' }} {{ scope.row.tax_rate > 0 ? ' of the excess over' : '' }} {{ scope.row.exemption ? Number(scope.row.exemption).toLocaleString(undefined, {minimumFractionDigits: 2}) : '' }}
              </template>
            </el-table-column>
            <el-table-column label="Operation" align="center" width="100px">
              <template slot-scope="scope">
                <el-button type="warning" size="small" @click="editDetails(scope.row)"><i class="fas fa-edit"/></el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="text-align: center;">
            <el-pagination :page-size="meta1.per_page" :pager-count="7" :total="meta1.total" :current-page.sync="meta1.page" layout="total, prev, pager, next" @current-change="getDetails"/>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-dialog :visible.sync="showform" :title="title" width="30%" center @close="closeModalDetails">
      <el-form ref="form" :model="form" :rules="formRules" label-position="top">
        <el-form-item label="Effectivity Date" prop="effective_date">
          <el-date-picker
            :key="key"
            v-model="form.effective_date"
            type="date"
            style="width: 100%"
            placeholder="Pick a day"/>
        </el-form-item>
        <el-form-item label="Status" prop="status">
          <el-select v-model="form.status" placeholder="Select...">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"/>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeModal">Cancel</el-button>
        <el-button type="primary" @click="save()">Save</el-button>
      </span>
    </el-dialog>
    <!--  tax details  -->
    <el-dialog :visible.sync="showformdetails" :title="title" width="30%" center @close="closeModalDetails">
      <el-form ref="formDetails" :model="formDetails" :rules="formRulesDetails" label-position="top">
        <el-form-item label="Tax bracket" prop="description">
          <el-input
            v-model="formDetails.description"
            :rows="2"
            type="textarea"
            placeholder="Please input ..... example (250000 = 400000)"/>
        </el-form-item>
        <el-form-item label="Tax rate (ex: 20% kindly put 20)" prop="tax_rate">
          <el-input
            v-model="formDetails.tax_rate"
            placeholder="Please input ..."/>
        </el-form-item>
        <el-form-item label="Tax exemption based on income range">
          <el-input
            v-model="formDetails.exemption"
            placeholder="Please input ..."/>
        </el-form-item>
        <el-form-item label="Fixed Tax based on income range">
          <el-input
            v-model="formDetails.fix_tax"
            placeholder="Please input ..."/>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeModalDetails">Cancel</el-button>
        <el-button type="primary" @click="saveDetails()">Save</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Others } from '@/api/payroll/others'
import { NotifySuccess } from '../../../helper/Helper'
export default {
  name: 'Taxtable',
  data() {
    return {
      formDetails: {
        'taxtable_id': null,
        'description': null,
        'tax_rate': 0,
        'exemption': '',
        'fix_tax': ''
      },
      showformdetails: false,
      showDetails: false,
      taxTableById: {},
      loadingDetails: false,
      meta1: {
        page: 1
      },
      tableDetails: [],
      key: 0,
      editable: false,
      loading: false,
      meta: {
        page: 1
      },
      title: 'Add data',
      showform: false,
      tableData: [],
      form: {
        'effective_date': this.getFormattedDate(new Date()),
        'status': 2
      },
      options: [
        {
          value: 1,
          label: 'Active'
        },
        {
          value: 2,
          label: 'In active'
        }
      ],
      formRules: {
        effective_date: [{ required: true, message: 'Effectivity date is required', trigger: 'blur' }],
        status: [{ required: true, message: 'Status number is required', trigger: 'blur' }]
      },
      formRulesDetails: {
        description: [{ required: true, message: 'Tax bracket is required', trigger: 'blur' }],
        tax_rate: [{ required: true, message: 'Tax rate is required', trigger: 'blur' }]
        // exemption: [{ required: true, message: 'Tax exemption is required', trigger: 'blur' }],
        // fix_tax: [{ required: true, message: 'Fix tax is required', trigger: 'blur' }]
      },
      isAllow: false
    }
  },
  created() {
    for (var i = 0; i < this.$store.getters.roles.length; i++) {
      var new_array = Object.entries(this.$store.getters.roles[i])
      for (var key = 0; key < new_array.length; key++) {
        if (new_array[key][1] === ('payroll_accounting')) {
          // console.log(new_array[key][1])
          this.isAllow = true
          this.getAll()
        }
      }
    }
  },
  methods: {
    splitDescription(data) {
      const myArray = data.split('=')
      var label = ''
      if (myArray.length > 1) {
        label = 'Over ' + Number(myArray[0]).toLocaleString(undefined, { minimumFractionDigits: 2 }) + ' but not over ' + Number(myArray[1]).toLocaleString(undefined, { minimumFractionDigits: 2 })
      } else {
        label = 'Not over ' + Number(myArray[0]).toLocaleString(undefined, { minimumFractionDigits: 2 })
      }
      return label
    },
    saveDetails() {
      if (this.editable === false) {
        this.formDetails.tax_details_id = null
      }
      this.$refs.formDetails.validate(valid => {
        if (valid) {
          const action = this.formDetails.tax_details_id ? 'updateTaxDetails' : 'storeTaxDetails'
          this.formDetails.taxtable_id = this.taxTableById.id
          this.loadingDetails = true
          Others(this.formDetails, 'post', action).then(res => {
            if (res.data.status === 'success') {
              if (action === 'updateTaxDetails') {
                NotifySuccess('Data Successfully Updated!')
              } else {
                NotifySuccess('Data Successfully Added!')
              }
              this.getDetails()
              this.closeModalDetails()
            }
          }).catch(error => {
            console.log(error)
          })
        }
      })
    },
    editDetails(data) {
      this.editable = true
      this.title = 'Edit data'
      this.showformdetails = true
      this.formDetails = {
        'tax_details_id': data.id,
        'taxtable_id': data.taxtable_id,
        'description': data.description,
        'tax_rate': data.tax_rate,
        'exemption': data.exemption,
        'fix_tax': data.fix_tax
      }
    },
    addDetails() {
      this.editable = false
      this.title = 'Add data'
      this.showformdetails = true
    },
    details(row) {
      this.showDetails = true
      this.taxTableById = row
      this.getDetails()
    },
    getDetails() {
      this.loadingDetails = true
      Others({ page: this.meta1.page, tax_id: this.taxTableById.id }, 'get', 'getTaxtablelist').then(res => {
        this.tableDetails = res.data.taxTableList
        this.meta1 = res.data.meta
        this.loadingDetails = false
      }).catch(error => {
        console.log(error)
      })
    },
    closeModalDetails() {
      this.editable = false
      this.showformdetails = false
      this.title = 'Add data'
      this.formDetails = {
        'taxtable_id': null,
        'description': null,
        'tax_rate': 0,
        'exemption': '',
        'fix_tax': ''
      }
    },
    closeModal() {
      this.editable = false
      this.showform = false
      this.title = 'Add data'
      this.form = {
        'effective_date': this.getFormattedDate(new Date()),
        'status': 2
      }
    },
    getAll() {
      this.loading = true
      Others({ page: this.meta.page }, 'get', 'getTaxtable').then(res => {
        this.tableData = res.data.taxTable
        this.meta = res.data.meta
        this.loading = false
      }).catch(error => {
        console.log(error)
      })
    },
    add() {
      this.editable = false
      this.title = 'Add data'
      this.showform = true
    },
    edit(data) {
      this.editable = true
      this.title = 'Edit data'
      this.showform = true
      this.form = {
        tax_id: data.id,
        effective_date: this.getFormattedDate(data.effective_date),
        status: data.status
      }
      this.key++
    },
    save() {
      if (this.editable === false) {
        this.form.tax_id = null
      }
      this.$refs.form.validate(valid => {
        if (valid) {
          const action = this.form.tax_id ? 'updateTaxtable' : 'storeTaxtable'
          this.form.effective_date = this.getFormattedDate(this.form.effective_date)
          this.loading = true
          Others(this.form, 'post', action).then(res => {
            if (res.data.status === 'success') {
              if (action === 'updateTaxtable') {
                NotifySuccess('Data Successfully Updated!')
              } else {
                NotifySuccess('Data Successfully Added!')
              }
              this.getAll()
              this.closeModal()
            }
          }).catch(error => {
            console.log(error)
          })
        }
      })
    },
    getFormattedDate(date) {
      return this.$moment(date).format('YYYY-MM-DD')
    }
  }
}
</script>

<style lang="scss">
</style>

